import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { withNamespaces } from 'react-i18next';
import PayBankBalance from '../bankBalance/payBank/PayBankBalance';
import VacationBankBalance from '../bankBalance/vacationBank/VacationBankBalance';
import LoadingOverlay from 'react-loading-overlay'
import BeatLoader from 'react-spinners/BeatLoader'
import i18next from 'i18next';

import styles from '../../styles/timesheet.module.css';

const useStyles = theme => ({
    accordionSummary: {
        color: 'var(--color2) !important'
    },
    iconExpanded: {
        color: 'var(--color2) !important'
    }
});

class RequestBankBalance extends Component {

    constructor(props) {
        super(props);

        this.state = {
            expanded: false,
            isActive: true,
            isActivePay: true,
            isActiveVacation: true,
        }
    }

    componentDidMount() {
        this.setState({ expanded: 'panel1' });
        this.resizeForm();
    }

    handleAccordion = (panel) => (event, isExpanded) => {
        this.setState({ expanded: isExpanded ? panel : false });
    };

    onIsLoadedPayBankBalance = (isLoaded) => {
        this.setState({ isActivePay: isLoaded }, () => {
            this.setIsActive();
        });
    }

    onIsLoadedVacationBankBalance = (isLoaded) => {
        this.setState({ isActiveVacation: isLoaded }, () => {
            this.setIsActive();
        });
    }

    setIsActive = () => {
        this.setState({ isActive: this.state.isActivePay || this.state.isActiveVacation });
    }

    resizeForm = () => {
        setTimeout(function () {
            const height = window.innerHeight;
            const titleBar = document.querySelector('#appBarTitle').clientHeight;
            const header = document.querySelector('[data-id=headerRequest]').style.height;
            const offSet = 100;

            // 90 => subtract the total div
            const customHeight = height - header - titleBar - offSet;

            document.querySelector('#divBank').style.height = `${customHeight}px`;
            document.querySelector('#divBank').style.overflowX = 'hidden';
        }, 1000);
    }

    render() {
        const { t } = this.props;
        const { classes } = this.props;

        return (
            <LoadingOverlay
                active={this.state.isActive}
                spinner={<BeatLoader />}
                text={i18next.t('request:form.loading')}
            >
                <div id="divBank" className={styles.rootTimesheetBank} style={{ marginTop: '5px'}}>
                    <Accordion className={classes.accordionSummary} expanded={this.state.expanded === 'panel1'} onChange={this.handleAccordion('panel1')}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon className={classes.iconExpanded} />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <div>{t("timesheet:bank-balance.payBank")}</div>
                        </AccordionSummary>
                        <AccordionDetails>
                            <PayBankBalance isFromBankBalanceMenu={false} isLoading={this.onIsLoadedPayBankBalance} />
                        </AccordionDetails>
                    </Accordion>
                    <Accordion className={classes.accordionSummary} expanded={this.state.expanded === 'panel2'} onChange={this.handleAccordion('panel2')}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon className={classes.iconExpanded} />}
                            aria-controls="panel2a-content"
                            id="panel2a-header"
                        >
                            <div>{t("timesheet:bank-balance.vacationBank")}</div>
                        </AccordionSummary>
                        <AccordionDetails>
                            <VacationBankBalance isFromBankBalanceMenu={false} isLoading={this.onIsLoadedVacationBankBalance} />
                        </AccordionDetails>
                    </Accordion>
                </div>
            </LoadingOverlay>
        )
    }
}

export default withNamespaces(['request', 'timesheet', 'bankBalance'], { wait: true })((withStyles(useStyles)(RequestBankBalance)));